export enum VERSION_TYPES {
  API = 'API',
  APP = 'APP',
}
